import { createSelector } from '@reduxjs/toolkit'
import { pickBy, includes, values } from 'lodash-es'

function getBase(state, props) {
  return state.data.timelineGridItems
}

export function getGridItems(state, props) {
  return getBase(state)
}

const getGridItemsSubset = createSelector(
  getGridItems,
  (state, props) => props.gridItemIds,
  (gridItems, gridItemIds) => pickBy(gridItems, item => includes(gridItemIds, item.id))
)

export const gridItemsListSelector = createSelector([getGridItems], function (gridItems) {
  return values(gridItems)
})

export const gridItemsSubsetListSelector = createSelector([getGridItemsSubset], function (gridItems) {
  return values(gridItems)
})
